module.exports = __webpack_public_path__ + "img/traditional.4a33e081.jpg";